import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import type { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'reports/contact/health/sources';

export function useContactHealthSourcesQuery({
	impersonationContext,
}: {
	impersonationContext?: Api.IImpersonationContext;
} = {}) {
	const userSession = useUserSession();
	const accountId = impersonationContext?.account?.id;
	return useQuery({
		queryKey: [BASE_QUERY_KEY, accountId, impersonationContext?.user?.id],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IContactHealthSourceOption[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'reports/contact/health/sources',
				}),
				'GET'
			),
		placeholderData: (previousData, previousQuery) =>
			previousQuery?.queryKey[1] === accountId ? previousData : undefined,
		meta: {
			errorLogging: { action: 'ContactHealthSourcesQuery-Error', category: 'ContactHealthReport' },
			toastErrorMessage: 'Failed to load contact sources.',
		} satisfies LevStandardQueryMeta,
	});
}
